module.exports = __webpack_public_path__ + "static/media/card_small_1.3d1a6ad0.svg";